module.exports = __webpack_public_path__ + "3477e32521b3b544f3b3c9c23c5853c4.MP3";